import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import { normalizeUnreadCounts } from './utils/unreadCounts.mjs';

export default function addMessageNavigation() {
  let unread = 0;
  let userId = null;
  let request = 0;
  const refresh = async () => {
    const user = app.session?.user?.id();
    const token = ++request;
    if (userId !== user) unread = 0;
    userId = user;
    if (!user) { m.redraw(); return; }
    try {
      const response = await app.request({ method: 'GET', url: `${app.forum.attribute('apiUrl')}/yingtao/unread-counts` });
      const counts = normalizeUnreadCounts(response);
      if (token === request && app.session?.user?.id() === user) {
        unread = Math.max(0, Number(counts.messages) || 0);
      }
    } catch (error) { /* Keep the last known badge during a temporary failure. */ }
    if (token === request) m.redraw();
  };
  // Flarum runs initializers before assigning session in its synchronous boot.
  Promise.resolve().then(refresh);
  setInterval(refresh, 15000);
  window.addEventListener('focus', refresh);
  extend(HeaderPrimary.prototype, 'items', function (items) {
    if (!app.session?.user) return;
    const count = app.session.user.id() === userId ? unread : 0;
    items.add('yingtaoMessages', LinkButton.component({ href: app.route('yingtaoMessages'), icon: 'fas fa-envelope', className: 'Button Button--link' }, [
      app.translator.trans('yingtao-forum-homepage.forum.private_messages.nav'),
      count > 0 && m('span.Button-badge', count > 99 ? '99+' : count),
    ]), 41);
  });
  extend(SessionDropdown.prototype, 'items', function (items) {
    if (!app.session?.user || !app.forum.attribute('canReviewMessages')) return;
    items.add('yingtaoMessageReports', LinkButton.component({ href: app.route('yingtaoMessageReports'), icon: 'fas fa-shield-alt' },
      app.translator.trans('yingtao-forum-homepage.forum.private_messages.review_nav')), 9);
  });
}
